export interface IPayProps {
  transactionId: string;
  planId: string;
  userId: number;
  amount: number;
  currency: string;
  email: string;
  description: string;
  bonusesUsed: number;
  onSuccess?: () => void;
  onFail?: () => void;
  onComplete?: () => void;
}
export const startPaymentWidget: (props: IPayProps) => void = ({
  transactionId,
  userId,
  planId,
  amount,
  currency,
  email,
  description,
  bonusesUsed,
  onSuccess,
  onComplete,
  onFail,
}) => {
  const widget = new (window as any).cp.CloudPayments({ cryptogramMode: false });
  // const key = `${import.meta.env.VITE_REACT_APP_CLOUD_PAYMENT_KEY}`;
  const key = (import.meta.env.VITE_REACT_APP_CLOUD_PAYMENT_KEY ?? '').trim();
  if (!key) {
    console.error('CloudPayments publicId is not configured. Please set VITE_REACT_APP_CLOUD_PAYMENT_KEY.');

    return;
  }

  widget.pay(
    'charge', //'auth', // или
    {
      //options
      publicId: key, //id из личного кабинета API KEY
      description: description, //назначение
      amount: amount,
      currency: currency,
      accountId: email,
      invoiceId: transactionId, //номер заказа  (необязательно)
      email: email, //email плательщика (необязательно)
      skin: 'mini', //дизайн виджета (необязательно)
      data: {
        planId: planId,
        userId: userId,
        bonusesUsed: bonusesUsed,
      },
    },
    {
      onSuccess:
        onSuccess ??
        function (options: any) {
          // fail
          //действие при успешной оплате
        },
      onFail:
        onFail ??
        function (reason: any, options: any) {
          // fail
          //действие при неуспешной оплате
        },
      onComplete:
        onComplete ??
        function (paymentResult: any, options: any) {
          //Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
          //например вызов вашей аналитики Facebook Pixel
        },
    },
  );
};
